export default {
  name: 'myoa-system-console',
  title: '信创OA'
}